import { ErrorState } from '@/components/common/ErrorState';
import { Layout } from '@/components/Layout';
import { useLogout } from '@/hooks/useLogout';

const INSTAGRAM_URL = 'https://www.instagram.com/wolishodotcom';

// Rendered when Auth0's redirect callback returns
// `error=access_denied&error_description=not_on_allowlist` — i.e. the
// post-login enforce-allowlist Action rejected the verified email.
// Without this, RequireAuth's auto-redirect bounces the user straight
// back to Universal Login on every mount, producing an infinite loop.
export function NotInvitedScreen() {
  // Clearing the Auth0 session is the only way out of the denial loop —
  // without it, the user's SSO cookie immediately re-authenticates them
  // on the next loginWithRedirect, the Action denies again, and we end
  // up right back here. `useLogout` redirects to the bare origin so
  // RequireAuth gets a clean mount with no error param in the URL.
  const logout = useLogout();
  const handleSignOut = () => {
    void logout();
  };

  return (
    <Layout>
      <ErrorState
        heading="You're not on the list yet"
        message="Wolisho is invite-only during the beta. DM us on Instagram to request access."
        onPrimaryAction={handleSignOut}
        primaryActionLabel="Sign in with a different account"
        primaryActionTestId="not-invited-sign-out"
        secondaryAction={{
          label: 'Message @wolishodotcom',
          href: INSTAGRAM_URL,
          testId: 'not-invited-instagram',
        }}
        testId="not-invited-screen"
      />
    </Layout>
  );
}
